import { Directive, EventEmitter, HostListener, Output } from "@angular/core";

@Directive({ selector: "[mouseScroll]" })
export class MouseScrollDirective {
    @Output() Up = new EventEmitter();
    @Output() Down = new EventEmitter();

    @HostListener("mousewheel", ["$event"])
    onMouseWheelChrome(event: WheelEvent) {
        this.mouseWheelFunc(event);
    }

    @HostListener("DOMMouseScroll", ["$event"])
    onMouseWheelFirefox(event: WheelEvent) {
        this.mouseWheelFunc(event);
    }

    @HostListener("onmousewheel", ["$event"])
    onMouseWheelIE(event: WheelEvent) {
        this.mouseWheelFunc(event);
    }

    mouseWheelFunc(event: WheelEvent) {
        if (!event) event = window.event as WheelEvent; //for IE support
        // Needs to remain as 'any' for compatibility with older browsers
        var delta = Math.max(-1, Math.min(1, (event as any).wheelDelta || -(event as any).detail));
        if (delta > 0) {
            this.Up.emit(event);
        } else if (delta < 0) {
            this.Down.emit(event);
        }

        //for IE
        (event as any).returnValue = false;
        //for Chrome and Firefox
        if (event.preventDefault) {
            event.preventDefault();
        }
    }
}
